import type {
  EntityID,
  EntityRegistry,
} from "@/shared/state/visualization/schema/v1/three-d";

/**
 * The lowest unused `entityN`, for naming a newly added entity.
 *
 * Lowest-unused rather than a count or a running max: deleting `entity1` and
 * adding again reuses that name instead of leaving a gap, and — the part that
 * matters — the result can never collide with a surviving entity. A collision
 * would be refused by the reducer, so "Add entity" would silently do nothing.
 */
export function nextEntityId(registry: EntityRegistry): EntityID {
  for (let index = 0; ; index++) {
    const candidate = `entity${index}`;
    if (!registry[candidate]) {
      return candidate;
    }
  }
}
